import Swiper from "swiper";
import SwiperCore, {
	Navigation,
	Pagination,
	Thumbs,
	EffectFade,
} from "swiper/core";
import ImageZoom from "js-image-zoom";

// window.onload = f;
function f() {
	var gclid = GetRequest("gclid");
    if(gclid!=""){
        localStorage.setItem("gclid", gclid);
    }
	
}
function GetRequest(value) {
	//url例子：www.bicycle.com?id="123456"&Name="bicycle"；
	var url = decodeURI(location.search); //?id="123456"&Name="bicycle";
	var object = {};
	if (url.indexOf("?") != -1) {
		//url中存在问号，也就说有参数。
		var str = url.substr(1); //得到?后面的字符串
		var strs = str.split("&"); //将得到的参数分隔成数组[id="123456",Name="bicycle"];
		for (var i = 0; i < strs.length; i++) {
			object[strs[i].split("=")[0]] = strs[i].split("=")[1];
		}
	}
	return object[value]||"";
}
f();
let imageZoom;

const createImageZoom = (wrapper, imageContainer) => {
	const options = {
		width: wrapper.offsetWidth,
		height: wrapper.offsetWidth,
		zoomWidth: wrapper.offsetWidth,
		offset: { vertical: 0, horizontal: 10 },
	};
	imageZoom && imageZoom.kill();
	imageZoom = new ImageZoom(imageContainer, options);
};

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Thumbs, EffectFade]);

const productThumb = new Swiper(".product-thumb", {
	observer: true,
	observerParents: true,
	observeSlideChildren: true,
	slidesPerView: 5,
	spaceBetween: 10,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
});

const productTop = new Swiper(".product-top", {
	// If we need pagination
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	observer: true,
	observerParents: true,
	observeSlideChildren: true,
	thumbs: {
		swiper: productThumb,
	},
	navigation: {
		nextEl: ".product-button-next",
		prevEl: ".product-button-prev",
	},
	on: {
		slideChange() {
			createImageZoom(
				document.getElementById("productTop"),
				productTop["slides"][productTop.activeIndex]
			);
		},
	},
});

const productTop1 = new Swiper(".product-top1", {
	// If we need pagination
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	observer: true,
	observerParents: true,
	observeSlideChildren: true,
	thumbs: {
		swiper: productThumb,
	},
	navigation: {
		nextEl: ".product-button-next",
		prevEl: ".product-button-prev",
	},
	on: {
	},
});

const extraProduct = new Swiper(".extra-product", {
	observer: true,
	observerParents: true,
	observeSlideChildren: true,
	slidesPerView: 6,
	spaceBetween: 30,
	navigation: {
		nextEl: ".extra-product-button-next",
		prevEl: ".extra-product-button-prev",
	},
});

createImageZoom(
	document.getElementById("productTop"),
	productTop["slides"][productTop.activeIndex]
);

window.onresize = () => {
	createImageZoom(
		document.getElementById("productTop"),
		productTop["slides"][productTop.activeIndex]
	);
};

window.productData = function () {
	return {
		price: 0,
		spec1: '',
		spec2: '',
		spec3: '',
		spec4: '',
		image: "",
		imageZoom: null,
		showImage: false,
        hostDomain: window.location.href,
        origin: window.location.origin,
		init: function () {
			if (this.priceList && this.priceList.length > 0) {
				// this.spec1 = this.priceList[0]["spec1"];
				// this.spec2 = this.priceList[0]["spec2"];
				// this.spec3 = this.priceList[0]["spec3"];
				// this.spec4 = this.priceList[0]["spec4"];
				this.setPrice();
			}
			window.onresize = () => {
				this.showImage = false;
			};
		},
		getPrice: function () {
			if (this.priceList && this.priceList.length > 0) {
				const priceList = JSON.parse(JSON.stringify(this.priceList));
				const result = priceList.filter(
					(price) =>
						this.spec1 == price["spec1"] &&
						this.spec2 == price["spec2"] &&
						this.spec3 == price["spec3"] &&
						this.spec4 == price["spec4"]
				);
				return result[0]?.salePrice;
			}
			return;
		},
		setPrice: function () {
				this.price = this.getPrice() || "-";
		},
		getImage: function (num) {
			let colorList = []
			if (num == 1) {
				colorList = JSON.parse(JSON.stringify(this.sepc1List));
				return colorList.filter(
					(color) => this.spec1 == color["dictItemCode"]
				)[0].image;
			}
			if (num == 2) {
				colorList = JSON.parse(JSON.stringify(this.sepc2List));
				return colorList.filter(
					(color) => this.spec2 == color["dictItemCode"]
				)[0].image;
			}
			if (num == 3) {
				colorList = JSON.parse(JSON.stringify(this.sepc3List));
				return colorList.filter(
					(color) => this.spec3 == color["dictItemCode"]
				)[0].image;
			}
			if (num == 4) {
				colorList = JSON.parse(JSON.stringify(this.sepc4List));
				return colorList.filter(
					(color) => this.spec4 == color["dictItemCode"]
				)[0].image;
			}
		},
		setImage: function (num) {
			this.image = this.getImage(num);
			this.showImage = true;
			this.$nextTick(() =>
				createImageZoom(
					document.getElementById("specImage"),
					document.getElementById("imageContainer")
				)
			);
		},
		hideImage: function () {
			this.showImage = false;
			this.$nextTick(() => 
                createImageZoom(
                    document.getElementById("productTop"),
                    productTop["slides"][productTop.activeIndex]
                )
            )
		},
		handleColor1: function (e) {
			this.spec1 = e.currentTarget.dataset.code;
			let num = e.currentTarget.dataset.spec;
			const elements = [...e.currentTarget.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.currentTarget.classList.add("border-2", "border-gray-500")
			this.setPrice();
			this.setImage(num);
		},
		handleSize1: function (e) {
			this.spec1 = e.target.dataset.code;
			const elements = [...e.target.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.target.classList.add("border-2", "border-gray-500")
			this.setPrice();
		},
		handleColor2: function (e) {
			this.spec2 = e.currentTarget.dataset.code;
			let num = e.currentTarget.dataset.spec;
			const elements = [...e.currentTarget.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.currentTarget.classList.add("border-2", "border-gray-500")
			this.setPrice();
			this.setImage(num);
		},
		handleSize2: function (e) {
			this.spec2 = e.target.dataset.code;
			const elements = [...e.target.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.target.classList.add("border-2", "border-gray-500")
			this.setPrice();
		},
		handleColor3: function (e) {
			this.spec3 = e.currentTarget.dataset.code;
			let num = e.currentTarget.dataset.spec;
			const elements = [...e.currentTarget.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.currentTarget.classList.add("border-2", "border-gray-500")
			this.setPrice();
			this.setImage(num);
		},
		handleSize3: function (e) {
			this.spec3 = e.target.dataset.code;
			const elements = [...e.target.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.target.classList.add("border-2", "border-gray-500")
			this.setPrice();
		},
		handleColor4: function (e) {
			this.spec4 = e.currentTarget.dataset.code;
			let num = e.currentTarget.dataset.spec;
			const elements = [...e.currentTarget.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.currentTarget.classList.add("border-2", "border-gray-500")
			this.setPrice();
			this.setImage(num);
		},
		handleSize4: function (e) {
			this.spec4 = e.target.dataset.code;
			const elements = [...e.target.parentElement.children]
			elements.forEach((element) => {
				element.classList.remove("border-2", "border-gray-500")
			})
			e.target.classList.add("border-2", "border-gray-500")
			this.setPrice();
		},
	};
};
